import authService from "@/services/auth.service.js";
import mailService from "@/services/mail.service.js";
import contactService from "@/services/contact.service";
import api from "@/services/api.js";
import userAccountService from "@/services/user-account.service";

const state = {
  user: null,
};

const mutations = {
  LOGIN(state, user) {
    state.user = user;
  },
  LOGOUT(state) {
    state.user = null;
  },
};

const actions = {
  async autoLogin({ commit, dispatch }) {
    let userData = tryGetUserData();
    if (userData) {
      if (hasExpired(userData.jwt)) {
        dispatch("logout");
        return null;
      }

      commit("LOGIN", userData.user);
      await dispatch("userAccount/fetchUserById", userData.user.id);

      let storageData = { jwt: "", user: {} };
      storageData.jwt = userData.jwt;
      storageData.user.id = userData.user.id;
      storageData.user.username = userData.user.username;
      storageData.user.first_name = userData.user.first_name;
      storageData.user.last_name = userData.user.last_name;
      localStorage.setItem("user", JSON.stringify(storageData));

      if (userData.user) {
        await dispatch("fetchPortfolios");
      }

      return userData.user;
    }
    return null;
  },
  async login({ commit, dispatch }, userObj) {
    let user = userObj.user;
    const contactCode = userObj.code;
    if (!user.email || !user.password) return null;
    try {
      let response = await authService.login(user);
      if (!response.user.confirmed) {
        await authService.logout();
        return "ERRNOTVERIFIED0152";
      }

      if (response.jwt) {
        commit("LOGIN", response.user);
        await dispatch("userAccount/fetchUserById", response.user.id);
        if (contactCode) {
          try {
            await contactService.connect(contactCode, response.user.id);

            const emailSubstituteFields = {
              First_Name: response.user.first_name,
              Last_Name: response.user.last_name,
            };
            mailService.sendEmail(
              "welcome_with_code",
              response.user.email,
              emailSubstituteFields
            );
          } catch (e) {
            console.log("Failed to connect contact to user");
          }
        }

        if (response.user.hidden_categories === undefined) {
          let data = {
            userId: response.user.id,
            hideCategories: false,
            confirmed: response.user.confirmed,
          };
          api.defaults.headers.common["Authorization"] =
            "Bearer " + response.jwt;
          const homepages = await api.get("/homepages");

          homepages.data.data.forEach((h) => {
            if (h.title === "Min information") {
              data.homepage = h;
            }
          });
          await userAccountService.updateUserData(data);
        }

        let storageData = { jwt: "", user: {} };
        storageData.jwt = response.jwt;
        storageData.user.id = response.user.id;
        storageData.user.username = response.user.username;
        storageData.user.first_name = response.user.first_name;
        storageData.user.last_name = response.user.last_name;
        localStorage.setItem("user", JSON.stringify(storageData));

        response.user.isOwnerOfPortfolio = await dispatch("fetchPortfolios");
        return response.user;
      } else {
        console.log("could not log in " + response);
      }
    } catch (error) {
      console.log(error.response ? error.response.status : error);
      commit("LOGOUT");
      return error.response;
    }

    return null;
  },
  logout({ commit, dispatch }) {
    authService.logout();
    dispatch("clearPortfolios");
    dispatch("clearCalendar");
    dispatch("clearArticles");
    dispatch("clearContacts");
    dispatch("clearVideoLibrary");
    dispatch("clearFiles");
    dispatch("clearPermissions");
    dispatch("userAccount/clearStoredUsers");

    commit("LOGOUT");
  },
  async register({ commit, dispatch }, userObj) {
    let user = userObj.user;
    const contactCode = userObj.code;

    if (!user.username || !user.email || !user.password) return null;

    try {
      const response = await authService.register(user, contactCode);

      if (response.jwt) {
        let connectionSuccessfull = false;
        if (contactCode) {
          let connectResponse;
          connectionSuccessfull = true;
          try {
            connectResponse = await contactService.connect(
              contactCode,
              response.user.id
            );
          } catch (e) {
            connectionSuccessfull = false;
          }

          if (true === connectionSuccessfull && connectResponse?.data) {
            const emailSubstituteFields = {
              First_Name: response.user.first_name,
              Last_Name: response.user.last_name,
            };

            mailService.sendEmail(
              "register_with_code",
              response.user.email,
              emailSubstituteFields
            );
            response.user.alreadyVerified = true;
            commit("LOGIN", response);

            api.defaults.headers.common["Authorization"] =
              "Bearer " + response.jwt;
            let storageData = { jwt: "", user: {} };
            storageData.jwt = response.jwt;
            storageData.user.id = response.user.id;
            storageData.user.username = response.user.username;
            storageData.user.first_name = response.user.first_name;
            storageData.user.last_name = response.user.last_name;
            localStorage.setItem("user", JSON.stringify(storageData));

            await dispatch("userAccount/fetchUserById", response.user.id);
            await dispatch("fetchPortfolios");
          }
        }

        if (
          !contactCode ||
          !response.user.alreadyVerified ||
          !connectionSuccessfull
        ) {
          const emailResponse = await userAccountService.initiateEmailVerification(
            response.user.email
          );
          const substituteData = {
            First_Name: response.user.first_name,
            Last_Name: response.user.last_name,
            Email_Verification_Code:
              response.user.id + "-" + emailResponse.data.reset_token,
          };
          await mailService.sendEmail(
            "email_verification",
            response.user.email,
            substituteData,
            false
          );
        }

        return response.user;
      } else {
        console.log("could not register " + response);
      }
    } catch (error) {
      console.log(error.response ? error.response.status : error);

      commit("LOGOUT");
    }
  },
};

const getters = {
  getUser: (state) => {
    return state.user;
  },
  isAuthenticated: (state) => !!state.user,
};

function tryGetUserData() {
  try {
    let userData = localStorage.getItem("user");
    if (userData) return JSON.parse(userData);
  } catch (error) {
    console.log(error);
    return null;
  }
  return null;
}

function hasExpired(jwt) {
  var currentTime = Date.now().valueOf() / 1000;
  return currentTime > jwt.exp;
}

export default {
  state,
  mutations,
  actions,
  getters,
};
